(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesEnableController',TabDeviceReleasesEnableController);

    TabDeviceReleasesEnableController.$inject = ['$uibModalInstance', 'entity', 'TabDeviceReleases'];

    function TabDeviceReleasesEnableController($uibModalInstance, entity, TabDeviceReleases) {
        var vm = this;
        vm.tabDeviceReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabDeviceReleases.isActive = true;
            TabDeviceReleases.update(vm.tabDeviceReleases,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
